import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import get from 'lodash/get';

import ChipField, { getChipColors } from '../../../common/fields/ChipField';


const PriorityField = ({ source = 'priority', size = 'small', ...props }) => {
    const record = useRecordContext(props);
    const translate = useTranslate();

    if (!record) {
        return null;
    }
    const priority = get(record, source);
    let sx = {};
    switch (priority) {
        case 'Bas':
            sx = getChipColors('blue');
            break;
        case 'Normal':
            sx = getChipColors('green');
            break;
        case 'Haut':
            sx = getChipColors('orange');
            break;
        case 'Urgent':
        case 'Très urgent':
            sx = getChipColors('red');
            break;
        default:
            break;
    }

    if (!priority) {
        return null;
    }

    const priorities = {
        'Bas': translate('Low'),
        'Normal': translate('Normal'),
        'Haut': translate('High'),
        'Urgent': translate('Urgent'),
        'Très urgent': translate('Very urgent')
    };

    return (
        <ChipField {...props} size={size} source={priority} record={priorities} sx={sx} />
    );
};

export default PriorityField;
